var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2243 16.472C15.0849 18.7604 18.5603 22.2247 20.8889 26.8821L18.6528 28.0001C16.5402 23.7746 13.3537 20.577 10.6626 18.4242C9.32152 17.3513 8.11569 16.5477 7.24924 16.0145C6.81637 15.7481 6.46924 15.5499 6.23357 15.4199C6.11577 15.3549 6.02591 15.307 5.96723 15.2762C5.93789 15.2608 5.91635 15.2497 5.90302 15.2429L5.88923 15.2359L5.88806 15.2353L5.88751 15.235C5.88753 15.235 5.88756 15.235 5.88806 15.2341L5.88803 13.0004C5.88753 12.9994 5.8875 12.9995 5.88748 12.9995L5.88803 12.9992L5.8892 12.9986L5.90299 12.9916C5.91633 12.9848 5.93786 12.9736 5.9672 12.9583C6.02589 12.9275 6.11574 12.8796 6.23355 12.8146C6.46922 12.6845 6.81635 12.4863 7.24922 12.2199C8.11567 11.6867 9.3215 10.8831 10.6626 9.81016C13.3537 7.65726 16.5402 4.45956 18.6528 0.234131L20.8889 1.35214C18.5603 6.00953 15.0849 9.47388 12.2244 11.7623C10.9705 12.7654 9.82541 13.5501 8.93064 14.1172C9.82541 14.6843 10.9705 15.469 12.2243 16.472Z",
    fill: "#00AFEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftarrow);
export default __webpack_public_path__ + "static/media/leftarrow.92c8fb238bc09a24920cd0c365f9e2ab.svg";
export { ForwardRef as ReactComponent };